import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// Components
import { PdpRespIconBubblePrint } from './PdpRespIconBubblePrint';

import { PdpRespIconBubbles } from './PdpRespIconBubbles';

import { PdpRespIconBubblesWrapper_viewer$data } from './__generated__/PdpRespIconBubblesWrapper_viewer.graphql';
import { PdpRespIconBubblesWrapper_item$data } from './__generated__/PdpRespIconBubblesWrapper_item.graphql';
import { PdpRespIconBubblesWrapper_user$data } from './__generated__/PdpRespIconBubblesWrapper_user.graphql';

import styles from './PdpRespIconBubblesWrapper.scss';

type Props = {
    relayVariables: {
        isTrade?: boolean;
    };
    viewer: PdpRespIconBubblesWrapper_viewer$data;
    item: PdpRespIconBubblesWrapper_item$data;
    user: PdpRespIconBubblesWrapper_user$data | null | undefined;
    skuId: string;
    dataTn?: string;
};

export const PdpRespIconBubblesWrapperComponent: FC<Props> = ({
    dataTn,
    relayVariables,
    ...props
}) => {
    const isPrivatePdp = props.item.isPublishedPrivate;
    if (isPrivatePdp) {
        return null;
    }

    const { isTrade } = relayVariables;

    return (
        <div className={styles.wrapper} data-tn={dataTn}>
            <PdpRespIconBubbles {...props} />
            <PdpRespIconBubblePrint isTrade={isTrade} />
        </div>
    );
};

export const PdpRespIconBubblesWrapper = createFragmentContainer(
    PdpRespIconBubblesWrapperComponent,
    {
        viewer: graphql`
            fragment PdpRespIconBubblesWrapper_viewer on Viewer {
                ...PdpRespIconBubbles_viewer
            }
        `,
        item: graphql`
            fragment PdpRespIconBubblesWrapper_item on Item {
                isPublishedPrivate
                ...PdpRespIconBubbles_item
            }
        `,
        user: graphql`
            fragment PdpRespIconBubblesWrapper_user on User {
                ...PdpRespIconBubbles_user
            }
        `,
    }
);
